<template>
  <v-progress-linear
    v-model="loaderData.value"
    :active="loaderData.show"
    :indeterminate="loaderData.query"
    :query="loaderData.query"
    v-if="loaderData.active"
  ></v-progress-linear>
</template>

<script>
  export default {
    name: 'loader',
    data () {
      return {
        
      }
    },

    mounted () {
      this.queryAndIndeterminate()
    },

    beforeDestroy () {
      clearInterval(this.loaderData.interval)
    },

    methods: {
      queryAndIndeterminate () {
        this.loaderData.query = true
        this.loaderData.show = true
        this.loaderData.value = 0

        /*setTimeout(() => {
          this.loaderData.query = false

          this.loaderData.interval = setInterval(() => {
            if (this.loaderData.value === 100) {
              clearInterval(this.loaderData.interval)
              this.loaderData.show = false
              return setTimeout(this.loaderData.queryAndIndeterminate, 2000)
            }
            this.loaderData.value += 25
          }, 1000)
        }, 2500)*/
      }
    },
    computed: {
        loaderData: {
            get(){
                return this.$store.state.loaderData;
            }
        }
    }
  }
</script>
<style scoped>
.v-progress-linear{    
    margin: 0px;
    /*position: absolute;*/
    position: fixed;
    bottom: 0px;
    z-index: 10;
}

</style>
